import { ServiceCookie } from './services';

export const servicesGuard = (item: ServiceCookie) => {
  const parentCodeGuard = 'parentCode' in item ? typeof item.parentCode === 'string' : true;
  const configuratorIdGuard = 'configuratorId' in item ? typeof item.configuratorId === 'number' : true;
  const parametersGuard = 'parameters' in item ? typeof item.parameters === 'object' : true;

  if (!item || typeof item !== 'object') return false;

  return (
    'code' in item &&
    typeof item.code === 'number' &&
    'quantity' in item &&
    typeof item.quantity === 'number' &&
    parentCodeGuard &&
    configuratorIdGuard &&
    parametersGuard
  );
};
